import React, { useRef } from "react";
import * as Icons from "react-feather";

import { useClickDetecter } from "lib/helpers";

export default function Notifications() {
  const [showMenu, setShowMenu] = React.useState(false);
  const wrapperRef = useRef(null);
  useClickDetecter(wrapperRef, (flag) => {
    setShowMenu(flag);
  });
  return (
    <>
      <div
        className="intro-x dropdown ml-4 sm:ml-6"
        ref={wrapperRef}
        style={{ zIndex: 49 }}
      >
        <div
          className="dropdown-toggle notification notification--light notification--bullet cursor-pointer"
          role="button"
          onClick={() => setShowMenu(!showMenu)}
        >
          <Icons.Bell className="notification__icon dark:text-gray-300" />
        </div>
        <div
          className={`notification-content pt-2 dropdown-menu ${
            showMenu ? "show" : ""
          }`}
          style={{
            width: "350px",
            position: "absolute",
            inset: "0px auto auto 0px",
            margin: 0,
            transform: "translate(8px, 15px)",
          }}
        >
          <div className="notification-content__box dropdown-menu__content box dark:bg-dark-6">
            <div className="notification-content__title">اعلان ها</div>
            <div className="cursor-pointer relative flex items-center">
              Comming Soon
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
